export default "__VITE_ASSET__e0429b69__"